// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"d9ad744e","351":"6d15a4a7","453":"d7446e4a","475":"542d9543","562":"03ae1be3","809":"6b11d9f8","893":"84305864"}[chunkId] + ".chunk.js";
};